'use strict';

angular.module('internal.licenses')
    .controller('InternalLicenseFormPermissions', ['$scope', '$stateParams', '$q', 'FBForms', 'FBFormPositionPermissions',
        function ($scope, $stateParams, $q, FBForms, FBFormPositionPermissions) {
        $scope.resetForm();
        $scope.saving = false;
        $scope.loading = true;
        $scope.parameters = { license_id: $stateParams.id };
        $scope.form_access = {};
        $scope.permissions_properties = {createdby: null, createdon: null, modifiedby: null, modifiedon: null};

        var promises = [];
            
        if ($stateParams.formID != null) {
            promises.push(FBFormPositionPermissions.get($stateParams.formID).then(function (permissions) {
                $scope.permissions = permissions;

                $scope.permissions_properties.modifiedon = $scope.permissions[0].permission.modified_on;
                $scope.permissions_properties.modifiedby = $scope.permissions[0].permission.modified_by_name;
                $scope.permissions_properties.createdon = $scope.permissions[0].permission.created_on;
                $scope.permissions_properties.createdby = $scope.permissions[0].permission.created_by_name;
            }));

            promises.push(FBForms.getAccess($stateParams.formID).then(function (access) {
                $scope.form_access = access;
            }));
        }

        $scope.save = function () {
            $scope.saving = true;
            var all = [];
            var savedPermissions = [];
            $scope.permissions.forEach(function(permission, i) {
                all.push(FBFormPositionPermissions.save($stateParams.formID, permission.permission).then(function (p) {
                    if (p != null && p.permission.id != null) {
                        savedPermissions[i] = p;
                    }
                }));
            });

            all.push(FBForms.saveAccess($stateParams.formID, $scope.form_access).then(function (access) {
                if (access != null) {
                    $scope.form_access = access;
                    $scope.form.applicant_access = access.applicant_access;
                    $scope.masterForm.applicant_access = access.applicant_access;
                }
            }));

            $q.all(all).then(function () {
                $scope.permissions = savedPermissions;
                $scope.permissions_properties.modifiedon = $scope.permissions[0].permission.modified_on;
                $scope.permissions_properties.modifiedby = $scope.permissions[0].permission.modified_by_name;
                $scope.saving = false;
            }).catch(function (response) {
                // handle error
            });
            
        }

        $q.all(promises).then(function () {
            $scope.loading = false;
        }).catch(function (response) {
            // handle error
        });

    }])
;